module.exports = __webpack_public_path__ + "static/img/wechat.5707e9f0.svg";